/* eslint-disable */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import ExpenseService from 'src/services/expense.service';

export const useAddExpense = (): UseMutationResult<any, Error, { expense: FormData }, void> =>
  useMutation((data: { expense: FormData }) => ExpenseService.addExpense(data.expense), {
    onSuccess: () => {
      AlertAdapter('Expense has been created.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useUpdateExpense = (): UseMutationResult<any, Error, { id: string; expense: FormData }, void> =>
  useMutation(({ id, expense }: { id: string; expense: FormData }) => ExpenseService.updateExpense(id, expense), {
    onSuccess: () => {
      AlertAdapter('Expense has been updated.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useApproveExpense = (): UseMutationResult<any, Error, { expenseId: string; expense: any }, void> =>
  useMutation(
    ({ expenseId, expense }: { expenseId: string; expense: any }) => ExpenseService.approveExpense(expenseId, expense),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useRejectExpense = (): UseMutationResult<any, Error, { expenseId: string; expense: any }, void> =>
  useMutation(
    ({ expenseId, expense }: { expenseId: string; expense: any }) => ExpenseService.rejectExpense(expenseId, expense),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useDeleteExpense = (): UseMutationResult<any, Error, { expenseId: string; expense: any }, void> =>
  useMutation(
    ({ expenseId, expense }: { expenseId: string; expense: any }) => ExpenseService.deleteExpense(expenseId, expense),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useDeleteExpenseWorker = (): UseMutationResult<any, Error, { expenseId: string; expense: any }, void> =>
  useMutation(
    ({ expenseId, expense }: { expenseId: string; expense: any }) =>
      ExpenseService.deleteExpenseWorker(expenseId, expense),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
